import { useTranslation } from "react-i18next";
import { ChangeEventHandler } from "react";
import { Select, SelectProps } from "shared/UI/Select/Select";

interface GenderSelectProps extends SelectProps {
  onChange: ChangeEventHandler;
  label: string;
  value: string;
  ["aria-describedby"]?: string;
};

export const GenderSelect = (props: GenderSelectProps) => {
  const { t } = useTranslation();

  return (
    <Select {...props}>
      <option value="prefer-not-to-say">{t("genderSelect.preferNotToSay")}</option>
      <option value="male">{t("genderSelect.male")}</option>
      <option value="female">{t("genderSelect.female")}</option>
      <option value="non-binary">{t("genderSelect.nonBinary")}</option>
    </Select>
  );
};
